import React from 'react';
import { connect } from 'react-redux';
import { resumeFromMagicLink, fetchIdPhotoIfNeeded } from 'registration/creative/ducks';
import Step2 from 'registration/creative/components/step2';

const mapStateToProps = ({creativeRegistration: { substep, magicLinkSentFromMobile }}) => ({
  substep,
  magicLinkSentFromMobile
})

export default connect(mapStateToProps, {
  resumeFromMagicLink,
  fetchIdPhotoIfNeeded
})(Step2);



// WEBPACK FOOTER //
// ./registration/creative/containers/step2.jsx